import { ReactComponent as IconWarning } from "../../assets/warning.svg";
import styles from "./Disable.module.scss";

interface DisableProps {
  systemMessage?: string;
}

const Disable: React.FC<DisableProps> = ({ systemMessage }) => {
  const normalizedSystemMessage = systemMessage?.trim();

  if (!normalizedSystemMessage) return null;

  return (
    <div className={styles.container}>
      <div className={styles.box}>
        <IconWarning height={61} width={61} />
        <div className={styles.message} role="alert">
          {normalizedSystemMessage}
        </div>
      </div>
    </div>
  );
};

export default Disable;
